import { createSlice } from '@reduxjs/toolkit';
import { incApi } from 'api/inc-api';

const sliceName = 'program';

const program = createSlice({
  name: sliceName,
  initialState: {
    current: null,
  },
  reducers: {
    setCurrent: (state, action) => {
      state.current = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      incApi.endpoints.listPrograms.matchFulfilled,
      (state, { payload }) => {
        if (payload?.programs?.length < 1) return;

        state.current = !state.current
          ? payload.programs[0].programId
          : payload.programs.find(
              program => program.programId === state.current,
            )?.programId ?? payload.programs[0].programId;
      },
    );
  },
});

// ACTIONS
export const programActions = {
  ...program.actions,
};

export default program;
